import { render, staticRenderFns } from "./PercentCard.vue?vue&type=template&id=976286ee&lang=pug&"
import script from "./PercentCard.vue?vue&type=script&lang=js&"
export * from "./PercentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports